import apiClient, { getApiErrorMessage } from './apiClient';

const unwrapApiData = (data) => data?.data || data?.Data || data;

const unwrapApiList = (data) => {
  const unwrapped = unwrapApiData(data);

  if (Array.isArray(unwrapped)) {
    return unwrapped;
  }

  if (Array.isArray(unwrapped?.items)) {
    return unwrapped.items;
  }

  if (Array.isArray(unwrapped?.Items)) {
    return unwrapped.Items;
  }

  return [];
};

const normalizeCategory = (category) => ({
  id: category?.Id || category?.id || '',
  name: category?.Name || category?.name || ''
});

export const fetchCategoriesApi = async () => {
  try {
    const { data } = await apiClient.get('/Categories');
    return unwrapApiList(data).map(normalizeCategory).filter((category) => category.id);
  } catch (error) {
    throw new Error(getApiErrorMessage(error, 'Categories request failed.'));
  }
};
